import axios from 'axios';
import { auth } from '../firebase';

const authApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
});

authApi.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default authApi;
